import React from "react";
import axios from "axios";
import moment from "moment";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Routes, { createTitle } from "routes";

export default class TermsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      results: [],
      error: undefined
    };
  }

  componentDidMount() {
    document.title = createTitle("Terms & Conditions", Routes);

    axios.get("/settings/policies/terms-conditions").then(response => {
      this.setState({
        isLoading: false,
        error: undefined,
        results: response.data
      });
    });
  }

  render() {
    const { results } = this.state;
    return (
      <section
        id="app-page-terms"
        className="app-terms-page terms-page content-page"
      >
        <header className="terms-page-hader page-header">
          <Container id="terms-header-row" className="header-row" fluid={true}>
            <Row>
              <Col className="text-center justify-content-center">
                <h1 className="page-title">
                  Terms <strong>&amp; Conditions</strong>
                </h1>
                <div className="sub-header">
                  <strong>Last Updated:</strong>{" "}
                  {results ? moment(results.updatedAt).calendar() : "Unknown"}
                </div>
              </Col>
            </Row>
          </Container>
        </header>

        <Container id="privacy-policy-row">
          <Row>
            <Col className="py-5">
              <div
                dangerouslySetInnerHTML={{
                  __html: results ? results.content : ""
                }}
              />
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
